import React, { useEffect, useState } from "react";
import { Col, Button, Row } from "reactstrap";
import { Colors,
    OutputRow,
    BoldLabel,
    LeftLabel,
    HighlightedCost,
    TableTitle,
    WhiteTableContainer,
    UnderlineButton,} from "../../../../utils/budget-tool-specific";
import { RebelColors } from "../../../../styles/rebel-experiences";

import AccommodationRow from "../../experiences/cost-summary/exp-accommodation-row";
import FlightRow from "../../experiences/cost-summary/exp-flight-row";
import ActivityRow from "../../experiences/cost-summary/exp-activity-row";
import TransportationRow from "../../experiences/cost-summary/exp-transportation-row";
import MealsRow from "../../experiences/cost-summary/exp-meals-row";
import MiscellaneousRow from "../../experiences/cost-summary/exp-miscellaneous-row";
import FinalCostRow from '../../experiences/cost-summary/final-cost-row';
import ContingencyRow from "../../experiences/cost-summary/exp-contingency-row";
import { displayValue } from "../../helper";
import { calculateSubCostPerAttendee,
    calculateTotalCostPerAttendee,
    calculateSubCostNoFlightsPerAttendee,
    calculateCostPerAttendee, } from "../../experiences/cost-summary/cost-helper";
import MeetingsRow from "../../experiences/cost-summary/exp-meetings.row";
import styled from "styled-components";
import CostOutput from "./rebel-cost-output";

const CostSummary = ({guideData, expData}) => {

    const [clientCurrency, setClientCurrency] = useState(true);

    const toggleCurrency = (value) => {
        setClientCurrency(value);
    }

    const activeButton = {
        backgroundColor: RebelColors.gold,
        border: "2px solid" + RebelColors.gold,
        borderRadius: "0px",
        color: "#000000"
    }
    const inactiveButton = {
        backgroundColor: "transparent",
        color: RebelColors.primary,
        border: "2px solid" + RebelColors.border,
        borderRadius: "0px"
    }

    const expDataRX = {...expData, base: {value: 1, invalid: false, required: true}, convert: {value: 1, invalid: false, required: true}};
    const guideDataRX = {...guideData, currency: {value: expData.destCurrency.value, invalid: false, required: true}};

    return (
            <React.Fragment>
            {guideData && expData && <React.Fragment>
                <Row>
                    <Col>
                        <h2 style={{color: RebelColors.primary, marginRight: "20px"}}>Cost Summary</h2>
                    </Col>
                    <Col style={{display: "flex", justifyContent:"flex-end", paddingRight: "30px"}}>
                    </Col>
                </Row>

                <br/>

                <h3 style={{color: RebelColors.gold}}>{expData.title.value}, {expData.location.value}</h3>
                {(expData.numberOfBedrooms?.value || expData.distanceFromAirport?.value || expData.nearestCity?.value || expData.distanceToCity?.value || expData.villaURL?.value) && (
                    <VillaDetailsContainer>
                        {expData.numberOfBedrooms?.value > 0 && <VillaDetail><strong>Bedrooms:</strong> {expData.numberOfBedrooms.value}</VillaDetail>}
                        {expData.distanceFromAirport?.value && <VillaDetail><strong>Distance from Airport:</strong> {expData.distanceFromAirport.value}</VillaDetail>}
                        {expData.nearestCity?.value && <VillaDetail><strong>Nearest City:</strong> {expData.nearestCity.value}</VillaDetail>}
                        {expData.distanceToCity?.value && <VillaDetail><strong>Distance to City:</strong> {expData.distanceToCity.value}</VillaDetail>}
                        {expData.villaURL?.value && <VillaDetail><strong>Property URL:</strong> <a href={expData.villaURL.value.startsWith('http') ? expData.villaURL.value : `https://${expData.villaURL.value}`} target="_blank" rel="noopener noreferrer" style={{color: RebelColors.primary}}>{expData.villaURL.value}</a></VillaDetail>}
                    </VillaDetailsContainer>
                )}
                <Row>
                    <Col>
                        <PrimaryButton style={clientCurrency ? activeButton : inactiveButton} onClick={() => {toggleCurrency(true)}}>{guideData.currency.value}</PrimaryButton>
                        <PrimaryButton style={!clientCurrency ? activeButton : inactiveButton} onClick={() => {toggleCurrency(false)}}>{expData.destCurrency.value}</PrimaryButton>
                    </Col>
                </Row>
           <br/>
                { clientCurrency && <CostOutput clientCurrency={clientCurrency} guideData={guideData} expData={expData} currencyConversionRatio={expData.base.value / expData.convert.value}/>}
                {!clientCurrency && <CostOutput clientCurrency={clientCurrency} guideData={guideDataRX} expData={expDataRX} currencyConversionRatio={expData.base.value / expData.convert.value}/>}
            </React.Fragment>}

        </React.Fragment>
    )
}

export default CostSummary;


const PrimaryButton = styled(Button)`
    color: ${props => props.style?.color || RebelColors.primary};
    &:hover {
        opacity: 0.8;
    }
`

const VillaDetailsContainer = styled.div`
    background-color: ${RebelColors.surface};
    border: 1px solid ${RebelColors.border};
    border-radius: 8px;
    padding: 16px;
    margin: 16px 0;
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
`

const VillaDetail = styled.div`
    color: ${RebelColors.primary};
    font-size: 14px;
    padding: 4px 12px;
    background-color: ${RebelColors.surfaceLight};
    border-radius: 4px;

    strong {
        color: ${RebelColors.gold};
        margin-right: 4px;
    }
`
